import { combineReducers } from "redux";
import usersReducer from "./usersReducer";
import homeReducer from "./homeReducer";
import accountReducer from "./accountReducer";
import memberTypeReducer from "./memberTypeReducer";
import totalPotInfoReducer from "./totalPotInfoReducer";
import manageReducer from "./manageReducer";
import investorReducer from "./investorReducer";
import accountPatch from "./accountPatchReducer";
import fundHistory from "./fundHistoryReducer";
import address from "./addressLookupReducer";
import uploadDoc from "./uploadDocReducer";
import submitDoc from "./submitDocReducer";
import fundsSavings from "./fundsSavingsReducer";
import memberList from "./memberListReducer";
import memberDetails from "./memberDetailsReducer";
import retirementApplication from "./retirementApplicationReducer";
import chatTokenReducer from "./chatTokenReducer";
import schemeProtection from "./schemeProtectionReducer";
import beneficiary from "./beneficiaryReducer";
import submitBeneficiaries from "./submitBeneficiariesReducer.js";
import addBeneficiaries from "./addBeneficiariesReducer.js";
import transactionsSummary from "./transactionsSummaryReducer";
import refreshToken from "./refreshTokenReducer.js";
import transferIn from "./transferInReducer.js";
import guidanceExplorer from "./guidanceExplorerReducer.js";
import guidanceExplorerCard from "./guidanceExplorerCardReducer.js";
import cmsFundListReducer from "./cmsFundListReducer.js";
import allDocumentReducer from "./allDocumentReducer.js";
import documentReducer from "./documentReducer.js";
import livingStandards from "./livingStandards.js";
import productOverview from "./productOverviewReducer.js";
import livingStandardAssumptions from "./livingStandardAssumptions.js";
import commPref from "./commPreferenceReducer.js";
import yourGoals from "./yourGoalsReducer.js";
import yourGoalsPost from "./yourGoalsPostReducer.js";
import uploadGetInTouchDocReducer from "./uploadGetInTouchDocReducer.js";
import footerContentReducer from "./footerContentReducer.js";
import learnLanding from "./learnLandingReducer.js";
import learnLandingFilter from "./learnLandingFilterReducer.js";
import learnFaq from "./learnFaqReducer.js";
import futureCalculatorHome from "./futureCalculatorHomeReducer.js";
import learnJargonBuster from "./learnJargonBuster.js";
import iWantToCombo from "./iWantToComboReducer.js";
import investments from "./investmentsReducer.js";
import calculateEstimatedPot from "./calculatePotReducer.js";
import retirementQr from "./retirementQrReducer.js";
import retirementIdentity from "./retirementIdentityReducer.js";
import homePromo from "./homePromoReducer.js";
import pushNotifications from "./getNotificationReducer.js";
import timeTravelAssumptions from "./timeTravelAssumptions.js";
import contributionRates from "./contributionRates.js";
import calculatorCMSConfig from "./calculatorCMSConfigReducer.js";
import contributionCalcPost from "./contributionCalcPostReducer.js";
import homeAlert from "./homeAlertReducer.js";
import traReducer from "./traReducer.js";
import connectedPension from "./connectedPensionReducer.js";
import futurecalculatorFlexi from "./futurecalculatorFlexiReducer.js";
import futurecalculatorIncome from "./futurecalculatorIncomeReducer.js";
import futurecalculatorAnnuity from "./futurecalculatorAnnuityReducer.js";
import futurecalculatorWorthAmount from "./futurecalculatorWorthAmountReducer.js";
import AboutTPT from "./aboutTPTReducer.js";
import futurecalculatorFlexiLinechart from "./futurecalculatorFlexiLinechartReducer.js";
import futurecalculatorFlexiIncomechart from "./futurecalculatorFlexiIncomechartReducer.js";
import futurecalculatorIncomechart from "./futurecalculatorIncomechartReducer.js";
import futurecalculatorAnnuitychart from "./futurecalculatorAnnuitychartReducer.js";
import futureCalculatorAssumptions from "./futureCalculatorAssumptions.js";
import learnHelpGuides from "./learnHelpGuides.js";
import SchemeDocumentReducer from "./schemeDocumentReducer.js";
import fundSwitch from "./fundSwitchReducer.js";
import drawdown from "./drawdownReducer.js";
import learnSupport from "./learnSupportReducer.js";
import transferOutReducer from "./transferOutReducer.js";
import usefulLinks from "./usefulLinksReducer.js";
import getMessages from "./messagesReducer.js";
import messagesRead from "./messagesReadReducer.js";
import lifeAssurance from "./LifeAssurance.js";
import postManageContribution from "./postManageContribution.js";
import Grades from "./grades.js";
import contributionView from "./contributionView.js";
import getTitleReducer from "./getTitleReducer.js";
import feedbackReducer from "./feedbackReducer.js";
import fundSwitchFuture from "./fundSwitchFutureReducer.js";
import helpGuidesIllustrations from "./helpGuidesIllustrations.js";
import faqIllustration from "./FaqIllustrations.js";
import jargonIllustration from "./jargonBusterIllustrations.js";
import getCountriesReducer from "./getCountriesReducer.js";
import changeInvestment from "./changeInvestmentReducer.js";
import lumpSumsWithdrawal from "./lumpSumsWithdrawalReducer.js";
import taxFreeIncomeCreateReducer from "./taxFreeIncomeCreateReducer.js";
import taxFreeIncomeStopReducer from "./taxFreeIncomeStopReducer.js";
import flexiAccessIncome from "./flexiAccessIncomeReducer.js";
import viewIllustration from "./viewIllustartionReducer.js";
import payoutRate from "./payoutRateReducer.js";
import raCMSFunds from "./raCMSFundsReducer.js";
import getPensionLabConsentReducer from "./getPensionLabConsentReducer.js";
import updatePensionLabConsentReducer from "./updatePensionLabConsentReducer.js";
import traChangeWithFundSwitchReducer from "./traChangeWhenFundSwitchRequired.js";

const rootReducer = combineReducers({
  users: usersReducer,
  investor: investorReducer,
  home: homeReducer,
  account: accountReducer,
  memberType: memberTypeReducer,
  totalPotInfo: totalPotInfoReducer,
  manage: manageReducer,
  accountPatch: accountPatch,
  fundHistory: fundHistory,
  address: address,
  uploadDoc: uploadDoc,
  submitDoc: submitDoc,
  fundsSavings: fundsSavings,
  memberList: memberList,
  memberDetails: memberDetails,
  retirementApplication: retirementApplication,
  chatToken: chatTokenReducer,
  schemeProtection: schemeProtection,
  beneficiary: beneficiary,
  submitBeneficiaries: submitBeneficiaries,
  addBeneficiaries: addBeneficiaries,
  transactionsSummary: transactionsSummary,
  refreshToken: refreshToken,
  transferIn: transferIn,
  guidanceExplorer: guidanceExplorer,
  guidanceExplorerCard: guidanceExplorerCard,
  cmsFundListReducer: cmsFundListReducer,
  allDocumentReducer: allDocumentReducer,
  documentReducer: documentReducer,
  livingStandards: livingStandards,
  productOverview: productOverview,
  livingStandardAssumptions: livingStandardAssumptions,
  commPref: commPref,
  yourGoals: yourGoals,
  yourGoalsPost: yourGoalsPost,
  uploadGetInTouchDocReducer: uploadGetInTouchDocReducer,
  footerContentReducer: footerContentReducer,
  learnLanding: learnLanding,
  learnLandingFilter: learnLandingFilter,
  learnFaq: learnFaq,
  futureCalculatorHome: futureCalculatorHome,
  learnJargonBuster: learnJargonBuster,
  iWantToCombo: iWantToCombo,
  investments: investments,
  calculateEstimatedPot: calculateEstimatedPot,
  retirementQr: retirementQr,
  retirementIdentity: retirementIdentity,
  homePromo: homePromo,
  pushNotifications: pushNotifications,
  timeTravelAssumptions: timeTravelAssumptions,
  contributionRates: contributionRates,
  calculatorCMSConfig: calculatorCMSConfig,
  contributionCalcPost: contributionCalcPost,
  homeAlert: homeAlert,
  traReducer: traReducer,
  connectedPension: connectedPension,
  futurecalculatorFlexi: futurecalculatorFlexi,
  futurecalculatorAnnuity: futurecalculatorAnnuity,
  futurecalculatorIncome: futurecalculatorIncome,
  futurecalculatorWorthAmount: futurecalculatorWorthAmount,
  AboutTPT: AboutTPT,
  futurecalculatorFlexiLinechart: futurecalculatorFlexiLinechart,
  futurecalculatorFlexiIncomechart: futurecalculatorFlexiIncomechart,
  futurecalculatorIncomechart: futurecalculatorIncomechart,
  futurecalculatorAnnuitychart: futurecalculatorAnnuitychart,
  futureCalculatorAssumptions: futureCalculatorAssumptions,
  learnHelpGuides: learnHelpGuides,
  SchemeDocumentReducer: SchemeDocumentReducer,
  fundSwitch: fundSwitch,
  drawdown: drawdown,
  learnSupport: learnSupport,
  transferOutReducer: transferOutReducer,
  usefulLinks: usefulLinks,
  getMessages: getMessages,
  messagesRead: messagesRead,
  lifeAssurance: lifeAssurance,
  postManage: postManageContribution,
  Grades: Grades,
  contributionView: contributionView,
  getTitleReducer: getTitleReducer,
  feedbackReducer: feedbackReducer,
  fundSwitchFuture: fundSwitchFuture,
  helpGuidesIllustrations: helpGuidesIllustrations,
  faqIllustration: faqIllustration,
  jargonIllustration: jargonIllustration,
  getCountriesReducer: getCountriesReducer,
  changeInvestment: changeInvestment,
  lumpSumsWithdrawal: lumpSumsWithdrawal,
  taxFreeIncomeCreateReducer: taxFreeIncomeCreateReducer,
  taxFreeIncomeStopReducer: taxFreeIncomeStopReducer,
  flexiAccessIncome: flexiAccessIncome,
  viewIllustration: viewIllustration,
  payoutRate: payoutRate,
  raCMSFunds: raCMSFunds,
  getPensionLabConsentReducer: getPensionLabConsentReducer,
  updatePensionLabConsentReducer: updatePensionLabConsentReducer,
  traChangeWithFundSwitchReducer: traChangeWithFundSwitchReducer,
});

export default rootReducer;
